// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Toast from "@cardoc/frontend-common/src/components/Toast.mjs";
import * as RelayRouter from "rescript-relay-router/src/RelayRouter.mjs";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as Router$CardocFrontendPartners from "./Router.mjs";
import * as RelayEnv$CardocFrontendPartners from "./RelayEnv.mjs";

function App(props) {
  return JsxRuntime.jsx(RescriptRelay.Context.Provider.make, {
              environment: RelayEnv$CardocFrontendPartners.environment,
              children: JsxRuntime.jsx(RelayRouter.Provider.make, {
                    value: Router$CardocFrontendPartners.routerContext,
                    children: JsxRuntime.jsx(Toast.Provider.make, {
                          children: JsxRuntime.jsx(RelayRouter.RouteRenderer.make, {
                                renderPending: (function (pending) {
                                    return JsxRuntime.jsx("div", {
                                                children: null
                                              });
                                  })
                              })
                        })
                  })
            });
}

var make = App;

export {
  make ,
}
/* Toast Not a pure module */
